import { useEffect, useState } from 'react';

import cookie from 'js-cookie';

const useIsLoggedIn = (initialState = false) => {
  const [isLoggedIn, setIsLoggedIn] = useState(initialState);

  useEffect(() => {
    setIsLoggedIn(
      !!cookie.get('eugenie_customer_token') &&
        !!cookie.get('eugenie_customer_email')
    );
  }, []);

  return isLoggedIn;
};

export default useIsLoggedIn;
